import { DateRow, PriceRow, TextRow, TypeRow } from 'components';
import React from 'react';
import {
  paymentMethodENums,
  paymentMethods,
  sourceList,
} from '../../../fragments/customerPayment/customerPaymentDetails/constants';

const statusEnums = {
  APPLIED: 'APPLIED',
  OPEN: 'OPEN',
  VOIDED: 'VOIDED',
}
export const customerPmtHead = [
  { name: '', title: 'Created Date', icon: 'date', type: 'date',  width: 150 },
  { name: '', title: 'Pmt Date', custom: false, width: 150 },
  { name: 'customer', searchKey: 'customer', title: 'Factoring/Customer', custom: false },
  {
    name: 'source', title: 'Source',
    filterList: [
      { name: 'All', id: '' },
      ...sourceList
    ],
  },
  {
    name: 'pmtMethod', title: 'Method',
    filterList: [
      { name: 'All', id: '' },
      ...paymentMethods
    ],
  },
  { name: 'applied',  searchKey:'used', title: 'Applied', custom: false },
  { name: 'total',  title: 'Total', custom: false },
  { name: '', title: 'Remaining', custom: false, smallSize: 8 },
  { name: 'reference', searchKey: 'reference', title: 'Ref. Number', custom: false, smallSize: 6 },
  {
    name: 'status', title: 'Status',
    filterList: [
      { name: 'All', id: '' },
      { name: 'Applied', id: 'APPLIED' },
      { name: 'Open', id: 'OPEN' },
      { name: 'Voided', id: 'VOIDED' },
    ],
  },
];

const renderColor = (item) => {
  switch (item?.status) {
    case statusEnums.OPEN:
      return '#F79009';

    case statusEnums.VOIDED:
      return '#438BFE';

    case statusEnums.APPLIED:
      return '#43BA4D';

    default:
      return '#51566d'
  }
}
export const customerPmtBody = [
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <DateRow date={item?.pmtDate} /> },
  { rowText: (item) => <TextRow name={item?.factoringName ? item?.factoringName : item?.customerName} /> },
  { rowText: (item) => <TypeRow text={item?.source}  /> },
  { rowText: (item) => <TypeRow text={item?.pmtMethod}  /> },
  { rowText: (item) => <PriceRow info={item?.used} /> },
  { rowText: (item) => <PriceRow info={item?.amount} /> },
  { rowText: (item) => <PriceRow info={item?.amount - item?.used} /> },
  { rowText: (item) => <TextRow name={item?.reference} /> },
  { rowText: (item) => <div style={{color: renderColor(item) }}><TypeRow text={item?.status} /></div> },
];

export const ACTION_TYPE = 'GET_CUSTOMER_PAYMENT';

export const customerPaymentsStatuses = [
  { id: 'OVERVIEW', name: 'Overview' },
  { id: 'DETAILED', name: 'Detailed' },
];

export const customerPaymentCsv = {
  type: 'customerPayment',
  statusList: customerPaymentsStatuses,
  dateFilter: true,
  requiredDateRange: true,
  requiredStatus: true,
};